(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product_default-size-v3"] && !Shopify.designMode) return;
  try {
    (function () {
    function ooDs3SetSelect(select, target) {
      if (!select || select.value === target) return;
      var options = select.querySelectorAll('option');
      var found = null;
      var i;
      for (i = 0; i < options.length; i++) {
        if (options[i].value === target && !options[i].disabled) {
          found = options[i];
          break;
        }
      }
      if (!found) return;
      select.value = target;
      var evt;
      try {
        evt = new Event('change', { bubbles: true });
      } catch (e) {
        evt = document.createEvent('Event');
        evt.initEvent('change', true, true);
      }
      select.dispatchEvent(evt);
    }

    function ooDs3ApplyShrine(target, applySticky) {
      var selects = document.querySelectorAll('quantity-breaks select.variant-dropdown[name="options[Size]"]');
      var i;
      for (i = 0; i < selects.length; i++) {
        ooDs3SetSelect(selects[i], target);
      }
      if (applySticky) {
        var stickySelects = document.querySelectorAll('sticky-atc select.variant-dropdown[name="options[Size]"]');
        for (i = 0; i < stickySelects.length; i++) {
          ooDs3SetSelect(stickySelects[i], target);
        }
      }
    }

    function ooDs3VerifyShrine(target, variants) {
      var items = document.querySelectorAll('.quantity-break__selector-item');
      if (!items.length) return false;
      for (var i = 0; i < items.length; i++) {
        var id = items[i].getAttribute('data-selected-id');
        if (!id || variants[id] !== target) return false;
      }
      return true;
    }

    function ooDs3FindSizeBtn(pair, target) {
      var btns = pair.querySelectorAll('.oo-bb-size');
      var i;
      for (i = 0; i < btns.length; i++) {
        if (btns[i].getAttribute('data-value') === target) return btns[i];
      }
      return null;
    }

    function ooDs3ApplyPair(pair, target) {
      if (pair.dataset.ooDs3Done) return;
      var btn = ooDs3FindSizeBtn(pair, target);
      if (!btn) return;
      if (!btn.classList.contains('oo-bb-off')) {
        btn.click();
      }
      pair.dataset.ooDs3Done = '1';
    }

    function ooDs3ApplyBuyBox(bb, target) {
      var pairs = bb.querySelectorAll('.oo-bb-pair');
      var i;
      for (i = 0; i < pairs.length; i++) {
        ooDs3ApplyPair(pairs[i], target);
      }
    }

    function ooDs3ApplySticky(target) {
      var stickySelects = document.querySelectorAll('sticky-atc select.variant-dropdown[name="options[Size]"]');
      for (var i = 0; i < stickySelects.length; i++) {
        ooDs3SetSelect(stickySelects[i], target);
      }
    }

    function ooDs3VerifyBuyBox(bb, target) {
      var pairs = bb.querySelectorAll('.oo-bb-pair');
      if (!pairs.length) return false;
      var i;
      for (i = 0; i < pairs.length; i++) {
        var pair = pairs[i];
        if (pair.dataset.ooDs3Done) continue;
        var on = pair.querySelector('.oo-bb-size.oo-bb-on');
        if (!on || on.getAttribute('data-value') !== target) return false;
      }
      return true;
    }

    function ooDs3StartBuyBox(bb, target, applySticky) {
      if (window.MutationObserver) {
        var mo = new MutationObserver(function () {
          ooDs3ApplyBuyBox(bb, target);
        });
        mo.observe(bb, { childList: true, subtree: true });
      }
      var attempts = 0;
      function tick() {
        attempts++;
        ooDs3ApplyBuyBox(bb, target);
        if (applySticky) ooDs3ApplySticky(target);
        if (ooDs3VerifyBuyBox(bb, target)) return;
        if (attempts < 20) {
          setTimeout(tick, 250);
        }
      }
      tick();
    }

    function ooDs3Init(root) {
      if (root.dataset.ooDs3Init) return;
      root.dataset.ooDs3Init = '1';

      var target = root.dataset.size;
      var respectUrl = root.dataset.respectUrl === 'true';
      var applySticky = root.dataset.sticky === 'true';

      if (respectUrl) {
        try {
          if (window.location.search.indexOf('variant=') !== -1) return;
        } catch (e) {}
      }

      if (!target) return;

      var bb = document.querySelector('.oo-bb');
      if (bb) {
        ooDs3StartBuyBox(bb, target, applySticky);
        return;
      }

      var variantsEl = root.querySelector('[data-oo-ds3-variants]');
      var variants = {};
      try {
        variants = variantsEl ? JSON.parse(variantsEl.textContent) : {};
      } catch (e) {}

      function start() {
        var attempts = 0;
        function tick() {
          attempts++;
          ooDs3ApplyShrine(target, applySticky);
          if (ooDs3VerifyShrine(target, variants)) return;
          if (attempts < 20) {
            setTimeout(tick, 250);
          }
        }
        tick();
      }

      if (window.customElements && window.customElements.whenDefined) {
        window.customElements.whenDefined('quantity-breaks').then(start, start);
      } else {
        start();
      }
    }

    document.querySelectorAll('[data-oo-ds3]').forEach(function (root) {
      ooDs3Init(root);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product_default-size"] && !Shopify.designMode) return;
  try {
    (function () {
    function ooDsSetSelect(select, target) {
      if (!select || select.value === target) return;
      var options = select.querySelectorAll('option');
      var found = null;
      var i;
      for (i = 0; i < options.length; i++) {
        if (options[i].value === target && !options[i].disabled) {
          found = options[i];
          break;
        }
      }
      if (!found) return;
      select.value = target;
      var evt;
      try {
        evt = new Event('change', { bubbles: true });
      } catch (e) {
        evt = document.createEvent('Event');
        evt.initEvent('change', true, true);
      }
      select.dispatchEvent(evt);
    }

    function ooDsApply(target, applySticky) {
      var selects = document.querySelectorAll('quantity-breaks select.variant-dropdown[name="options[Size]"]');
      var i;
      for (i = 0; i < selects.length; i++) {
        ooDsSetSelect(selects[i], target);
      }
      if (applySticky) {
        var stickySelects = document.querySelectorAll('sticky-atc select.variant-dropdown[name="options[Size]"]');
        for (i = 0; i < stickySelects.length; i++) {
          ooDsSetSelect(stickySelects[i], target);
        }
      }
    }

    function ooDsVerify(target, variants) {
      var items = document.querySelectorAll('.quantity-break__selector-item');
      if (!items.length) return false;
      for (var i = 0; i < items.length; i++) {
        var id = items[i].getAttribute('data-selected-id');
        if (!id || variants[id] !== target) return false;
      }
      return true;
    }

    function ooDsInit(root) {
      if (root.dataset.ooDsInit) return;
      root.dataset.ooDsInit = '1';

      var target = root.dataset.size;
      var respectUrl = root.dataset.respectUrl === 'true';
      var applySticky = root.dataset.sticky === 'true';

      var isDesignMode = !!(window.Shopify && window.Shopify.designMode);
      if (isDesignMode) {
        root.classList.add('oo-ds--editor');
        root.removeAttribute('hidden');
      }

      if (respectUrl) {
        try {
          if (window.location.search.indexOf('variant=') !== -1) return;
        } catch (e) {}
      }

      if (!target) return;

      var variantsEl = root.querySelector('[data-oo-ds-variants]');
      var variants = {};
      try {
        variants = variantsEl ? JSON.parse(variantsEl.textContent) : {};
      } catch (e) {}

      function start() {
        var attempts = 0;
        function tick() {
          attempts++;
          ooDsApply(target, applySticky);
          if (ooDsVerify(target, variants)) return;
          if (attempts < 20) {
            setTimeout(tick, 250);
          }
        }
        tick();
      }

      if (window.customElements && window.customElements.whenDefined) {
        window.customElements.whenDefined('quantity-breaks').then(start, start);
      } else {
        start();
      }
    }

    document.querySelectorAll('[data-oo-ds]').forEach(function (root) {
      ooDsInit(root);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product_fair-pricing"] && !Shopify.designMode) return;
  try {
    (function () {
    if (!document.getElementById('oo-fp-fonts')) {
      var pc1 = document.createElement('link');
      pc1.rel = 'preconnect';
      pc1.href = 'https://fonts.googleapis.com';
      var pc2 = document.createElement('link');
      pc2.rel = 'preconnect';
      pc2.href = 'https://fonts.gstatic.com';
      pc2.crossOrigin = 'anonymous';
      var link = document.createElement('link');
      link.id = 'oo-fp-fonts';
      link.rel = 'stylesheet';
      link.href = 'https://fonts.googleapis.com/css2?family=Hanken+Grotesk:wght@400;500;600;700&family=Instrument+Serif:ital@1&display=swap';
      document.head.appendChild(pc1);
      document.head.appendChild(pc2);
      document.head.appendChild(link);
    }
  })();

  var OO_FP_BRACE_OPEN = String.fromCharCode(123, 123);
  var OO_FP_BRACE_CLOSE = String.fromCharCode(125, 125);
  var OO_FP_DEFAULT_FORMAT = '$' + OO_FP_BRACE_OPEN + 'amount' + OO_FP_BRACE_CLOSE;

  function ooFpFormatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || OO_FP_DEFAULT_FORMAT;

    function defaultOption(opt, def) { return (typeof opt === 'undefined' || opt === null) ? def : opt; }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number === null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = formatString.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    switch (key) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ', '');
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', ',');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }
    return match ? formatString.replace(placeholderRegex, value) : formatString + value;
  }

  function ooFpComputeRows(P, cfg) {
    var keys = ['production', 'packaging', 'shipping', 'webshop', 'payment', 'share'];
    var sum = 0;
    keys.forEach(function (k) { sum += cfg[k] || 0; });
    if (sum <= 0) sum = 1;
    var out = {};
    var runningSum = 0;
    ['production', 'packaging', 'shipping', 'webshop', 'payment'].forEach(function (k) {
      var share = (cfg[k] || 0) / sum;
      var amountCents = Math.round(P * share);
      out[k] = amountCents;
      runningSum += amountCents;
    });
    out.selling = P;
    out.share = P - runningSum;
    return out;
  }

  document.querySelectorAll('[data-oo-fp]').forEach(function (root) {
    if (root.dataset.ooFpInit) return;
    root.dataset.ooFpInit = '1';

    var moneyFormat = root.dataset.moneyFormat || OO_FP_DEFAULT_FORMAT;
    var variantsData = root.querySelector('[data-oo-fp-variants]');
    var rowsData = root.querySelector('[data-oo-fp-rows]');
    var variants = variantsData ? JSON.parse(variantsData.textContent) : {};
    var rowsRaw = rowsData ? JSON.parse(rowsData.textContent) : {};
    var rowsCfg = {};
    Object.keys(rowsRaw).forEach(function (k) { rowsCfg[k] = parseFloat(rowsRaw[k]) || 0; });

    var compareEl = root.querySelector('[data-oo-fp-compare]');
    var priceEl = root.querySelector('[data-oo-fp-price]');
    var savingsEl = root.querySelector('[data-oo-fp-savings]');
    var savingsTemplate = savingsEl ? (savingsEl.getAttribute('data-savings-template') || '') : '';
    var lastVariantId = null;

    function getVariantId() {
      try {
        var params = new URLSearchParams(window.location.search);
        var fromUrl = params.get('variant');
        if (fromUrl && variants[fromUrl]) return fromUrl;
      } catch (e) {}
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (input && input.value && variants[input.value]) return input.value;
      // Fall back to any [name="id"] on the page whose value is one of THIS product's
      // variants (other cart-add forms on the page — e.g. an upsell widget — can share
      // the [name="id"] selector but point at a different product's variant id).
      var candidates = document.querySelectorAll('[name="id"]');
      for (var i = 0; i < candidates.length; i++) {
        var val = candidates[i].value;
        if (val && variants[val]) return val;
      }
      return root.dataset.initialVariant;
    }

    function render(variantId) {
      var v = variants[variantId];
      if (!v) return;
      var P = v.p;
      var C = v.c;
      var hasCompare = C > P;

      if (priceEl) priceEl.textContent = ooFpFormatMoney(P, moneyFormat);
      if (compareEl) {
        compareEl.textContent = ooFpFormatMoney(C, moneyFormat);
        compareEl.hidden = !hasCompare;
      }
      if (savingsEl) {
        savingsEl.hidden = !hasCompare;
        if (hasCompare) {
          var pct = Math.floor(((C - P) * 100) / C);
          var amt = ooFpFormatMoney(C - P, moneyFormat);
          savingsEl.textContent = savingsTemplate.replace(/\[percentage\]/g, pct + '%').replace(/\[amount\]/g, amt);
        }
      }

      var rows = ooFpComputeRows(P, rowsCfg);
      Object.keys(rows).forEach(function (k) {
        var el = root.querySelector('[data-oo-fp-amount="' + k + '"]');
        if (el) el.textContent = ooFpFormatMoney(rows[k], moneyFormat);
      });
    }

    function poll() {
      var vid = getVariantId();
      if (vid && vid !== lastVariantId) {
        lastVariantId = vid;
        render(vid);
      }
    }
    poll();
    setInterval(poll, 500);

    function setupModal(modal, openers) {
      if (!modal) return;
      document.body.appendChild(modal);
      var closers = modal.querySelectorAll('[data-oo-fp-close]');
      var onKeydown = function (e) { if (e.key === 'Escape') close(); };

      function open() {
        // Close any other oo-fp modal (this root's other modal, or another block
        // instance's) so two sheets never sit open at the same time.
        document.querySelectorAll('.oo-fp-modal.is-open').forEach(function (other) {
          if (other !== modal) other.dispatchEvent(new CustomEvent('oofpclose'));
        });
        modal.hidden = false;
        requestAnimationFrame(function () { modal.classList.add('is-open'); });
        document.documentElement.style.overflow = 'hidden';
        document.body.classList.add('oo-fp-locked');
        document.addEventListener('keydown', onKeydown);
      }
      function close() {
        modal.classList.remove('is-open');
        document.documentElement.style.overflow = '';
        document.body.classList.remove('oo-fp-locked');
        document.removeEventListener('keydown', onKeydown);
        window.setTimeout(function () { modal.hidden = true; }, 340);
      }
      openers.forEach(function (btn) {
        btn.addEventListener('click', function (e) { e.preventDefault(); open(); });
      });
      closers.forEach(function (btn) { btn.addEventListener('click', close); });
      modal.addEventListener('oofpclose', close);
      // Modal B has no dedicated backdrop element (its dark overlay is a ::after on
      // the modal root, like Qomfort's); a click that lands on the modal root itself
      // (not on the wrap/sheet inside it) is a backdrop click.
      modal.addEventListener('click', function (e) {
        if (e.target === modal) close();
      });
    }

    setupModal(root.querySelector('[data-oo-fp-modal-a]'), root.querySelectorAll('[data-oo-fp-open-a]'));
    setupModal(root.querySelector('[data-oo-fp-modal-b]'), root.querySelectorAll('[data-oo-fp-open-b]'));

    root.querySelectorAll('.oo-fp-tip-btn').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var tip = btn.closest('.oo-fp-tip');
        var wasOpen = tip.classList.contains('is-open');
        document.querySelectorAll('.oo-fp-tip.is-open').forEach(function (t) { t.classList.remove('is-open'); });
        if (!wasOpen) tip.classList.add('is-open');
      });
    });
    document.addEventListener('click', function () {
      document.querySelectorAll('.oo-fp-tip.is-open').forEach(function (t) { t.classList.remove('is-open'); });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product_preorder-notice-v3"] && !Shopify.designMode) return;
  try {
    (function () {
    function ooPo3VariantState(v) {
      if (!v.a) return 'sold_out';
      if (v.m && v.q <= 0 && v.p === 'continue') return 'preorder';
      return 'in_stock';
    }

    function ooPo3Worst(states) {
      if (states.indexOf('sold_out') !== -1) return 'sold_out';
      if (states.indexOf('preorder') !== -1) return 'preorder';
      return 'in_stock';
    }

    function ooPo3FallbackId(root, variants) {
      try {
        var params = new URLSearchParams(window.location.search);
        var fromUrl = params.get('variant');
        if (fromUrl && variants[fromUrl]) return fromUrl;
      } catch (e) {}
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (input && input.value && variants[input.value]) return input.value;
      return root.dataset.initialVariant;
    }

    function ooPo3BuyBoxIds(bb, lookup) {
      var pairs = bb.querySelectorAll('.oo-bb-pair:not([hidden])');
      var ids = [];
      var i;
      for (i = 0; i < pairs.length; i++) {
        var colorEl = pairs[i].querySelector('.oo-bb-swatch.oo-bb-on');
        var sizeEl = pairs[i].querySelector('.oo-bb-size.oo-bb-on');
        var color = colorEl ? colorEl.getAttribute('data-value') : null;
        var size = sizeEl ? sizeEl.getAttribute('data-value') : null;
        if (!size) continue;
        var key = (color || '') + '||' + size;
        var id = lookup[key];
        if (id) ids.push(id);
      }
      return ids;
    }

    function ooPo3SelectedIds(root, variants, lookup) {
      var bb = document.querySelector('.oo-bb');
      if (bb) {
        var ids = ooPo3BuyBoxIds(bb, lookup);
        if (ids.length) return ids;
      }
      var fallback = ooPo3FallbackId(root, variants);
      return fallback ? [fallback] : [];
    }

    document.querySelectorAll('[data-oo-po3]').forEach(function (root) {
      if (root.dataset.ooPo3Init) return;
      root.dataset.ooPo3Init = '1';

      var variantsData = root.querySelector('[data-oo-po3-variants]');
      var configData = root.querySelector('[data-oo-po3-config]');
      var lookupData = root.querySelector('[data-oo-po3-lookup]');
      var variants = variantsData ? JSON.parse(variantsData.textContent) : {};
      var cfg = configData ? JSON.parse(configData.textContent) : {};
      var lookup = lookupData ? JSON.parse(lookupData.textContent) : {};

      var statusTextEl = root.querySelector('[data-oo-po3-status-text]');
      var boxEl = root.querySelector('[data-oo-po3-box]');
      var lastKey = null;
      var bbObserver = null;

      function render(state, forced) {
        root.setAttribute('data-state', state);
        if (statusTextEl) statusTextEl.textContent = (cfg.texts && cfg.texts[state]) || '';

        var showBox = false;
        if (state === 'preorder') {
          showBox = !!cfg.showBox;
        } else if (state === 'sold_out') {
          showBox = !!cfg.showBox && !!cfg.showBatchesSoldOut;
        }
        if (boxEl) boxEl.hidden = !showBox;

        if (forced) {
          root.hidden = false;
        } else if (state === 'in_stock' && !cfg.showInStock) {
          root.hidden = true;
        } else {
          root.hidden = false;
        }
      }

      function computeAndRender() {
        var isDesignMode = !!(window.Shopify && window.Shopify.designMode);
        var forced = isDesignMode && cfg.editorPreview && cfg.editorPreview !== 'auto';
        var state, key;
        if (forced) {
          state = cfg.editorPreview;
          key = 'editor:' + state;
        } else {
          var ids = ooPo3SelectedIds(root, variants, lookup);
          var states = [];
          for (var i = 0; i < ids.length; i++) {
            var v = variants[ids[i]];
            if (v) states.push(ooPo3VariantState(v));
          }
          state = states.length ? ooPo3Worst(states) : 'in_stock';
          key = ids.join(',') + '|' + state;
        }
        if (key === lastKey) return;
        lastKey = key;
        render(state, forced);
      }

      function attachBbObserver() {
        if (bbObserver) return true;
        var bb = document.querySelector('.oo-bb');
        if (!bb) return false;
        if (window.MutationObserver) {
          bbObserver = new MutationObserver(computeAndRender);
          bbObserver.observe(bb, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'hidden'] });
        }
        return true;
      }

      computeAndRender();
      attachBbObserver();
      setInterval(function () {
        if (!bbObserver) attachBbObserver();
        computeAndRender();
      }, 500);
      document.addEventListener('click', computeAndRender);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product_preorder-notice"] && !Shopify.designMode) return;
  try {
    (function () {
    function ooPoVariantState(v) {
      if (!v.a) return 'sold_out';
      if (v.m && v.q <= 0 && v.p === 'continue') return 'preorder';
      return 'in_stock';
    }

    function ooPoWorst(states) {
      if (states.indexOf('sold_out') !== -1) return 'sold_out';
      if (states.indexOf('preorder') !== -1) return 'preorder';
      return 'in_stock';
    }

    function ooPoActiveTierIds(qb) {
      var tiers = qb.querySelectorAll('.quantity-break');
      var active = null;
      var i;
      for (i = 0; i < tiers.length; i++) {
        var forId = tiers[i].getAttribute('for');
        if (forId) {
          var input = document.getElementById(forId);
          if (input && input.checked) {
            active = tiers[i];
            break;
          }
        }
      }
      if (!active) active = tiers[0];
      if (!active) return [];
      var items = active.querySelectorAll('.quantity-break__selector-item');
      var ids = [];
      for (i = 0; i < items.length; i++) {
        var id = items[i].getAttribute('data-selected-id');
        if (id) ids.push(id);
      }
      return ids;
    }

    function ooPoFallbackId(root, variants) {
      try {
        var params = new URLSearchParams(window.location.search);
        var fromUrl = params.get('variant');
        if (fromUrl && variants[fromUrl]) return fromUrl;
      } catch (e) {}
      var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
      if (input && input.value && variants[input.value]) return input.value;
      return root.dataset.initialVariant;
    }

    function ooPoSelectedIds(root, variants) {
      var qbList = document.querySelectorAll('quantity-breaks');
      if (qbList.length) {
        var ids = ooPoActiveTierIds(qbList[0]);
        if (ids.length) return ids;
      }
      var fallback = ooPoFallbackId(root, variants);
      return fallback ? [fallback] : [];
    }

    document.querySelectorAll('[data-oo-po]').forEach(function (root) {
      if (root.dataset.ooPoInit) return;
      root.dataset.ooPoInit = '1';

      var variantsData = root.querySelector('[data-oo-po-variants]');
      var configData = root.querySelector('[data-oo-po-config]');
      var variants = variantsData ? JSON.parse(variantsData.textContent) : {};
      var cfg = configData ? JSON.parse(configData.textContent) : {};

      var statusTextEl = root.querySelector('[data-oo-po-status-text]');
      var boxEl = root.querySelector('[data-oo-po-box]');
      var lastKey = null;

      function render(state, forced) {
        root.setAttribute('data-state', state);
        if (statusTextEl) statusTextEl.textContent = (cfg.texts && cfg.texts[state]) || '';

        var showBox = false;
        if (state === 'preorder') {
          showBox = !!cfg.showBox;
        } else if (state === 'sold_out') {
          showBox = !!cfg.showBox && !!cfg.showBatchesSoldOut;
        }
        if (boxEl) boxEl.hidden = !showBox;

        if (forced) {
          root.hidden = false;
        } else if (state === 'in_stock' && !cfg.showInStock) {
          root.hidden = true;
        } else {
          root.hidden = false;
        }
      }

      function computeAndRender() {
        var isDesignMode = !!(window.Shopify && window.Shopify.designMode);
        var forced = isDesignMode && cfg.editorPreview && cfg.editorPreview !== 'auto';
        var state, key;
        if (forced) {
          state = cfg.editorPreview;
          key = 'editor:' + state;
        } else {
          var ids = ooPoSelectedIds(root, variants);
          var states = [];
          for (var i = 0; i < ids.length; i++) {
            var v = variants[ids[i]];
            if (v) states.push(ooPoVariantState(v));
          }
          state = states.length ? ooPoWorst(states) : 'in_stock';
          key = ids.join(',') + '|' + state;
        }
        if (key === lastKey) return;
        lastKey = key;
        render(state, forced);
      }

      computeAndRender();
      setInterval(computeAndRender, 500);
      document.addEventListener('change', computeAndRender);

      if (window.MutationObserver) {
        var qbList = document.querySelectorAll('quantity-breaks');
        for (var i = 0; i < qbList.length; i++) {
          var mo = new MutationObserver(computeAndRender);
          mo.observe(qbList[i], { subtree: true, attributes: true, attributeFilter: ['data-selected-id'] });
        }
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product_qomfort-buy-box"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-oo-bb]').forEach(function (root) {
      if (root.dataset.ooBbInit) return;
      root.dataset.ooBbInit = '1';

      var cfg = JSON.parse(root.querySelector('[data-oo-bb-config]').textContent);
      var colorIndex = parseInt(root.dataset.colorIndex, 10);
      var sizeIndex = parseInt(root.dataset.sizeIndex, 10);
      var colorName = root.dataset.colorName;
      var sizeName = root.dataset.sizeName;
      var shipDays = parseInt(root.dataset.shipDays, 10) || 1;
      var fakeStockMin = parseInt(root.dataset.fakeStockMin, 10) || 8;
      var fakeStockMax = parseInt(root.dataset.fakeStockMax, 10) || 40;
      // 2026-09-16 Boss: low-stock banner only for these colours (empty = all colours)
      var lowStockColors = String(root.dataset.lowStockColors || '').split(',').map(function (c) { return c.trim().toLowerCase(); }).filter(Boolean);
      function showLowStock(color) { return lowStockColors.length === 0 || lowStockColors.indexOf(String(color).toLowerCase()) !== -1; }
      var pairsWrap = root.querySelector('.oo-bb-pairs');
      // 2026-09-16: shipping flag follows the shopper's country (ISO -> regional-indicator emoji)
      (function () {
        var f = root.querySelector('.oo-bb-flag'); if (!f) return;
        var iso = String(f.getAttribute('data-country-iso') || '').toUpperCase();
        if (!f.getAttribute('data-country-flag') && /^[A-Z]{2}$/.test(iso)) f.textContent = String.fromCodePoint(0x1F1E6 + iso.charCodeAt(0) - 65, 0x1F1E6 + iso.charCodeAt(1) - 65);
      })();
      var template = root.querySelector('[data-oo-bb-pair-template]');
      var atcBtn = root.querySelector('[data-oo-bb-atc]');
      var atcTotal = root.querySelector('[data-oo-bb-atc-total]');
      var atcCompare = root.querySelector('[data-oo-bb-atc-compare]');
      var errorEl = root.querySelector('[data-oo-bb-error]');
      var hasDuo = !!root.querySelector('.oo-bb-pack[data-pack="duo"]');
      var pack = hasDuo && root.dataset.defaultPack === 'duo' ? 'duo' : 'single';

      // "EU=USW=USM" lines -> chart + lookup by size option value
      var chart = {};
      var euByValue = {};
      String(cfg.sizeChart || '').split(/\r?\n/).forEach(function (line) {
        var parts = line.split('=').map(function (s) { return s.trim(); });
        if (parts.length < 3) return;
        chart[parts[0]] = { usW: parts[1], usM: parts[2] };
      });
      cfg.sizeValues.forEach(function (val) {
        Object.keys(chart).forEach(function (eu) {
          var row = chart[eu];
          if (val.indexOf('US Women ' + row.usW + ' ') === 0 || val === 'US Women ' + row.usW + ' - US Men ' + row.usM || val === eu || val === 'EU ' + eu) euByValue[val] = eu;
        });
      });
      var swatchHex = {};
      String(cfg.swatches || '').split(/\r?\n/).forEach(function (line) {
        var parts = line.split('=');
        if (parts.length < 2) return;
        swatchHex[parts[0].trim().toLowerCase()] = parts[1].trim();
      });
      var LIGHT = ['white', 'beige', 'cream', 'ivory'];

      function optionOf(variant, index) { return index === 0 ? variant.option1 : index === 1 ? variant.option2 : variant.option3; }
      function findVariant(color, sizeVal) {
        return cfg.variants.find(function (vr) {
          return (colorIndex < 0 || optionOf(vr, colorIndex) === color) && optionOf(vr, sizeIndex) === sizeVal;
        }) || null;
      }
      function sizeAvailable(color, sizeVal) {
        var vr = findVariant(color, sizeVal);
        return !!(vr && vr.available);
      }
      function isPreorder(vr) {
        if (!vr || !vr.available) return false;
        if (!Array.isArray(cfg.invIds) || !Array.isArray(cfg.invQty) || !Array.isArray(cfg.invPolicy)) return false;
        var idx = cfg.invIds.indexOf(vr.id);
        if (idx < 0) return false;
        var tracked = !!vr.inventory_management;
        return tracked && cfg.invQty[idx] <= 0 && cfg.invPolicy[idx] === 'continue';
      }
      function colorAvailable(color) {
        if (colorIndex < 0) return cfg.variants.some(function (vr) { return vr.available; });
        return cfg.variants.some(function (vr) { return optionOf(vr, colorIndex) === color && vr.available; });
      }
      function labelFor(sizeVal, unit) {
        var eu = euByValue[sizeVal];
        if (!eu) return sizeVal;
        if (unit === 'us-w') return chart[eu].usW;
        if (unit === 'us-m') return chart[eu].usM;
        return eu;
      }

      // Deterministic "fake" low-stock count: same product+color+day always hashes to the same number.
      function hashStr(str) {
        var h = 0;
        for (var i = 0; i < str.length; i++) {
          h = (h * 31 + str.charCodeAt(i)) >>> 0;
        }
        return h;
      }
      function todayLocal() {
        var d = new Date();
        var mm = String(d.getMonth() + 1);
        if (mm.length < 2) mm = '0' + mm;
        var dd = String(d.getDate());
        if (dd.length < 2) dd = '0' + dd;
        return d.getFullYear() + '-' + mm + '-' + dd;
      }
      function fakeStock(color) {
        var seed = String(cfg.productId) + '|' + String(color).toLowerCase() + '|' + todayLocal();
        var h = hashStr(seed);
        var range = fakeStockMax - fakeStockMin + 1;
        return fakeStockMin + (h % range);
      }

      var pairs = [];
      function firstAvailable() {
        var vr = cfg.variants.find(function (x) { return x.available; }) || cfg.variants[0];
        return { color: colorIndex < 0 ? '' : optionOf(vr, colorIndex), size: optionOf(vr, sizeIndex) };
      }

      function makePair(num) {
        var frag = template.content.cloneNode(true);
        var el = frag.querySelector('.oo-bb-pair');
        el.querySelector('[data-pair-num]').textContent = num;
        // 2026-09-16 Boss: pair #2 opens expanded on first click (was collapsed, needed a second click)
        var init = firstAvailable();
        var state = { color: init.color, size: init.size, unit: 'us-w', el: el };
        var swatches = el.querySelector('[data-swatches]');
        var sizes = el.querySelector('[data-sizes]');
        var colorBox = el.querySelector('[data-color-box]');
        if (colorIndex < 0) colorBox.hidden = true;

        cfg.colorValues.forEach(function (c) {
          var b = document.createElement('button');
          b.type = 'button';
          var key = c.toLowerCase();
          b.className = 'oo-bb-swatch' + (LIGHT.indexOf(key) >= 0 ? ' oo-bb-light' : '');
          b.style.backgroundColor = swatchHex[key] || '#cccccc';
          b.title = c;
          b.setAttribute('data-value', c);
          b.addEventListener('click', function () {
            if (b.classList.contains('oo-bb-off')) return;
            state.color = c;
            state.colorChanged = true;
            if (!sizeAvailable(state.color, state.size)) {
              var firstOk = cfg.sizeValues.find(function (s) { return sizeAvailable(state.color, s); });
              if (firstOk) state.size = firstOk;
            }
            render();
          });
          swatches.appendChild(b);
        });
        cfg.sizeValues.forEach(function (s) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'oo-bb-size';
          b.setAttribute('data-value', s);
          b.addEventListener('click', function () {
            if (b.classList.contains('oo-bb-off')) return;
            state.size = s;
            render();
          });
          sizes.appendChild(b);
        });
        // Shared by the unit-tab clicks below and the ooFmsOpen callback (2026-09-16: quiz result
        // now passes its own unit back) so there is one code path that keeps the tab highlight,
        // state.unit and the size-grid labels in sync — see render()'s [data-sizes] loop.
        function setUnit(unit) {
          state.unit = unit;
          el.querySelectorAll('.oo-bb-unit').forEach(function (x) { x.classList.toggle('oo-bb-on', x.getAttribute('data-unit') === unit); });
          render();
        }
        el.querySelectorAll('.oo-bb-unit').forEach(function (u) {
          u.addEventListener('click', function () { setUnit(u.getAttribute('data-unit')); });
        });
        el.querySelector('[data-guide]').addEventListener('click', function () {
          var btn = document.querySelector('.sizing-chart__button, .product-popup-modal__button');
          if (btn) btn.click(); else window.open('/pages/size-guide', '_blank');
        });
        el.querySelector('.oo-bb-pair-head').addEventListener('click', function () { el.classList.toggle('oo-bb-pair-open'); });
        el.querySelector('[data-quiz]').addEventListener('click', function (e) {
          e.preventDefault();
          if (typeof window.ooFmsOpen !== 'function') return;
          window.ooFmsOpen(function (eu, unit) {
            var row = chart[String(eu)];
            if (!row) return;
            var target = cfg.sizeValues.find(function (s) { return euByValue[s] === String(eu); });
            if (!target) return;
            state.size = target;
            if (!sizeAvailable(state.color, state.size)) {
              var okColor = cfg.colorValues.find(function (c) { return sizeAvailable(c, state.size); });
              if (okColor) state.color = okColor;
            }
            // 2026-09-16: follow the unit the customer landed on in the quiz result tabs (US W /
            // US M / EU) so the buy box's own unit tab + size-grid labels match it on return.
            if (unit === 'eu' || unit === 'us-w' || unit === 'us-m') setUnit(unit);
            else render();
          });
        });

        function render() {
          el.querySelector('[data-color-val]').textContent = state.color;
          swatches.querySelectorAll('.oo-bb-swatch').forEach(function (b) {
            var c = b.getAttribute('data-value');
            b.classList.toggle('oo-bb-on', c === state.color);
            b.classList.toggle('oo-bb-off', !colorAvailable(c));
          });
          sizes.querySelectorAll('.oo-bb-size').forEach(function (b) {
            var s = b.getAttribute('data-value');
            b.textContent = labelFor(s, state.unit);
            b.classList.toggle('oo-bb-on', s === state.size);
            b.classList.toggle('oo-bb-off', !sizeAvailable(state.color, s));
          });
          el.querySelector('[data-size-val]').textContent = labelFor(state.size, state.unit);
          var vr = findVariant(state.color, state.size);

          if (state.colorChanged && vr && vr.featured_media && vr.featured_media.id) {
            var gallery = document.querySelector('media-gallery');
            if (gallery && typeof gallery.setActiveMedia === 'function') {
              var mediaId = cfg.sectionId + '-' + vr.featured_media.id;
              if (gallery.querySelector('[data-media-id="' + mediaId + '"]')) {
                var filt = gallery.dataset.filteringOption && gallery.dataset.filteringOption !== 'none';
                try { gallery.setActiveMedia(mediaId, true, filt, filt ? vr : null); } catch (e) {}
              }
            }
          }
          state.colorChanged = false;

          var stock = el.querySelector('[data-stock]');
          if (vr && colorAvailable(state.color) && showLowStock(state.color)) {
            var n = fakeStock(state.color);
            stock.hidden = false;
            el.querySelector('[data-stock-color]').textContent = state.color || labelFor(state.size, state.unit);
            el.querySelector('[data-stock-count]').textContent = n;
            el.querySelector('[data-stock-fill]').style.width = Math.max(6, Math.round(n / fakeStockMax * 100)) + '%';
          } else {
            stock.hidden = true;
          }

          var pre = el.querySelector('[data-preorder]');
          if (pre) {
            if (vr && isPreorder(vr) && cfg.showPreorderNote) {
              pre.hidden = false;
              el.querySelector('[data-preorder-text]').textContent = (cfg.preorderSizeText || '')
                .replace(/\[size\]/g, labelFor(state.size, state.unit))
                .replace(/\[color\]/g, state.color || '');
            } else {
              pre.hidden = true;
            }
          }
          if (typeof updateShipLine === 'function') updateShipLine();
        }
        state.render = render;
        state.variant = function () { return findVariant(state.color, state.size); };
        render();
        return state;
      }

      function updateShipLine() {
        var by = root.querySelector('.oo-bb-ship-by');
        var pre = root.querySelector('[data-oo-bb-ship-pre]');
        if (!by || !pre) return;
        var mode = cfg.preorderShipMode || 'off';
        var any = false;
        if (mode === 'always') {
          any = true;
        } else if (mode === 'auto') {
          var need = pack === 'duo' ? 2 : 1;
          for (var i = 0; i < Math.min(need, pairs.length); i++) {
            if (isPreorder(pairs[i].variant())) { any = true; break; }
          }
        }
        by.hidden = any;
        pre.hidden = !any;
      }

      function setPack(next) {
        pack = next;
        root.querySelectorAll('.oo-bb-pack').forEach(function (b) { b.classList.toggle('oo-bb-on', b.getAttribute('data-pack') === pack); });
        var need = pack === 'duo' ? 2 : 1;
        while (pairs.length < need) { var p = makePair(pairs.length + 1); pairsWrap.appendChild(p.el); pairs.push(p); }
        pairs.forEach(function (p, i) { p.el.hidden = i >= need; });
        var second = root.querySelector('[data-oo-bb-second]');
        if (second) second.hidden = pack === 'duo';
        if (pack === 'duo') {
          atcTotal.textContent = cfg.money.duoTotal;
          atcCompare.textContent = cfg.money.duoCompare;
          atcCompare.hidden = false;
        } else {
          atcTotal.textContent = cfg.money.single;
          atcCompare.textContent = cfg.money.singleCompare;
          atcCompare.hidden = !cfg.money.hasCompare;
        }
        updateShipLine();
      }
      root.querySelectorAll('.oo-bb-pack').forEach(function (b) {
        b.addEventListener('click', function () { setPack(b.getAttribute('data-pack')); });
      });
      var secondBtn = root.querySelector('[data-oo-bb-second]');
      if (secondBtn) secondBtn.addEventListener('click', function () { setPack('duo'); });

      atcBtn.addEventListener('click', function () {
        errorEl.hidden = true;
        var need = pack === 'duo' ? 2 : 1;
        var items = [];
        for (var i = 0; i < need; i++) {
          var vr = pairs[i].variant();
          if (!vr || !vr.available) { errorEl.textContent = 'Please pick an available color and size for pair #' + (i + 1) + '.'; errorEl.hidden = false; return; }
          items.push({ id: vr.id, quantity: 1 });
        }
        var drawer = document.querySelector('cart-drawer');
        var body = { items: items };
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
          body.sections_url = window.location.pathname;
        }
        atcBtn.disabled = true;
        fetch(cfg.cartUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, json: j }; }); })
          .then(function (res) {
            atcBtn.disabled = false;
            if (!res.ok) { errorEl.textContent = res.json.description || res.json.message || 'Could not add to cart.'; errorEl.hidden = false; return; }
            if (drawer && typeof drawer.renderContents === 'function' && res.json.sections) {
              try { drawer.renderContents(res.json); return; } catch (e) {}
            }
            window.location.href = cfg.cartPage;
          })
          .catch(function () { atcBtn.disabled = false; window.location.href = cfg.cartPage; });
      });

      // Ships by: next business day(s) from today, e.g. "Mon, September 14th"
      function shipDate() {
        var d = new Date();
        var added = 0;
        while (added < shipDays) {
          d.setDate(d.getDate() + 1);
          if (d.getDay() !== 0 && d.getDay() !== 6) added++;
        }
        var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
        var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        var n = d.getDate();
        var suffix = (n % 10 === 1 && n !== 11) ? 'st' : (n % 10 === 2 && n !== 12) ? 'nd' : (n % 10 === 3 && n !== 13) ? 'rd' : 'th';
        return days[d.getDay()] + ', ' + months[d.getMonth()] + ' ' + n + suffix;
      }
      var shipEl = root.querySelector('[data-oo-bb-ship-date]');
      if (shipEl) shipEl.textContent = shipDate();

      setPack(pack);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
